export default __webpack_public_path__ + "static/media/github.6c955556.svg";